import styles from './App.module.scss'
import { useState } from 'react'
import TreeView from './components/treeView/treeView'
import Main from './components/main/main'
import Navbar from './components/navbar/navbar'
import ApiForm from './components/apiForm/apiForm'
import React from 'react'
import { dataSchema } from './utils/zodFetchValidation'

function App() {
    const [data, setData] = useState<FetchedData>()
    const [moduleObject, setModuleObject] = useState<ModuleObject>()
    const [apiFormError, setApiFormError] = useState(false)
    const [fetching, setFetching] = useState(false)

    const fetchData = async (apiKey: string): Promise<void> => {
        setFetching(true)
        if (
            process.env.NODE_ENV === 'development' ||
            process.env.NODE_ENV === 'test'
        ) {
            //Dummy fetch method for development

            fetch('dummyData.json', {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + apiKey,
                },
            })
                .then((response) => {
                    if (apiKey !== 'test')
                        throw new Error(
                            'error fetching data. Check your api key is correct'
                        )
                    return response.json()
                })
                .then((json) => {
                    dataSchema.parse(json)
                    setData(json)
                    setModuleObject(json.modules[3])
                    setFetching(false)
                })
                .catch((error) => {
                    setApiFormError(true)
                    setFetching(false)
                    console.error(error)
                })
        } else {
            //Production Fetch Method
            let baseUrl = document.location.pathname.split('/')[1]
            const API_URL = `https://${window.location.hostname}/${baseUrl}modules`

            fetch(API_URL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + apiKey,
                },
            })
                .then((response) => {
                    return response.json()
                })
                .then((json) => {
                    dataSchema.parse(json)
                    setData(json)
                    setModuleObject(json.modules[3])
                    setFetching(false)
                })
                .catch((error) => {
                    setApiFormError(true)
                    setFetching(false);
                    console.error(error)
                })
        }
    }
    return (
        <div className={styles.App}>
            <Navbar />
            <div className={styles.viewbox}>
                {data ? (
                    <>
                        <TreeView
                            modules={data.modules.sort(function(a: ModuleObject, b: ModuleObject){
                                const nameA = a.module.toUpperCase();
                                const nameB = b.module.toUpperCase();
                                if (nameA < nameB) {
                                    return -1;
                                } else {
                                    return 1;
                                }
                            })}
                            setReadme={setModuleObject}
                        />
                        <Main
                            moduleObject={moduleObject}
                            setModuleObject={setModuleObject}
                            modules={data.modules}
                        />
                    </>
                ) : (
                    <ApiForm
                        fetchData={fetchData}
                        error={apiFormError}
                        fetching={fetching}
                    />
                )}
            </div>
        </div>
    )
}

export default App
